import { useLocation } from "react-router";
import { MobileBottomNavComponent } from "./MobileBottomNavComponent";

export function MobileBottomNav() {
	const { pathname } = useLocation();

	return <MobileBottomNavComponent pathname={pathname} />;
}
